import React, {useEffect, useContext,useCallback} from 'react';
import styles from './info.module.css';
//import {sensorFailedItem} from '../../../App';
import CommonMenu from '../../menu/commonMenu';
import {useMenu} from '../../../hooks/useMenu';
import useKeyPress from '../../../hooks/useKeyPress';
import Acknowledge from '../acknowledge';
import SubMenuView from '../../views/subMenuView';
import MenuContext from '../../../context/menuContext';
import CommandsContext from '../../../context/commandsContext';
import Home from '../../home';
import { displaySetList } from '../../../App';

function Info({onExit}) {
  const {topText, top, infoContent} = styles;
  const {
    setShowAck,
    setShowInfo,
    setsensorError,
    showAck,
    showInfo,
    sensorError,
    onComponent,
    info,
    alert,
    setInfo,
  } = useContext(MenuContext);
  const onLeft = useCallback(() => {
    //onComponent(<RunVerification />);
    onExit();
  }, []);

  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit});
  }, [onExit, onLeft]);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // useEffect(() => {
  //   if (!leftPress) return;
  //   onComponent(<Acknowledge />);
  // }, [leftPress]);

  useEffect(() => {
    if (alert === false) {
      //onExit();
    }
  }, [alert]);

  return (
    <SubMenuView
      title="Sensor Failed"
      menuItems={displaySetList}
      content="Resolve the following conditions"
      onExit={() => onComponent(<Home />)}
      //onLeftCallback={() => onComponent(<Acknowledge />)}
    />
  );
}

export default Info;
